// extracted by mini-css-extract-plugin
export var clearBtn = "optionschecker-module--clear-btn--68dc2";
export var fieldGroup = "optionschecker-module--fieldGroup--3639c";
export var fieldLabel = "optionschecker-module--fieldLabel--ec686";
export var fieldSpan = "optionschecker-module--fieldSpan--a8827";
export var fieldsetInput = "optionschecker-module--fieldset-input--c6a9f";
export var fieldsetRoot = "optionschecker-module--fieldset-root--1d398";
export var iconRoot = "optionschecker-module--icon-root--6a690";
export var optionChecker = "optionschecker-module--option-checker--ca161";